__webpack_require__.p = "https://stage-company-panels.dotsdev.live/";